module.exports = __webpack_public_path__ + "img/cd648a144e3362305b8aed6486979bdd.5a531177.jpg";